import {v4, validate} from "uuid";

export const getUniqueIdentifier = () => {
    return v4();
}

export const isUniqueIdentifier = (identifier: string) => {
    return validate(identifier);
}
